module.exports = __webpack_public_path__ + "static/img/user_story3.3321d11c.png";